/**
 * Global MaterialReactTable configuration.
 *
 * Column filtering is handled client-side (no API calls).
 * The "strictContains" filter requires the search term to appear
 * as a contiguous substring — e.g. "spain" matches "Spain" or
 * "Visit Spain!" but NOT a fuzzy/scattered match like "spaIN123".
 */

/** Custom filter function: case-insensitive strict substring (%value%). */
const strictContains = (row, columnId, filterValue) => {
  const cellValue = row.getValue(columnId);
  if (cellValue == null) return false;
  return String(cellValue)
    .toLowerCase()
    .includes(String(filterValue).toLowerCase().trim());
};

// Label shown in the MRT filter-mode dropdown (optional but useful)
strictContains.autoRemove = (val) => !val;

/**
 * Wraps a column definition array so every column explicitly uses
 * strictContains. MRT's defaultColumn.filterFn is unreliable across
 * versions — per-column declaration is the only guaranteed approach.
 * Individual columns can still override by passing their own filterFn.
 *
 * Usage:
 *   const tableColumns = useMemo(() => withStrictFilter([...]), [...]);
 */
export const withStrictFilter = (columns) =>
  columns.map((col) => ({ filterFn: "strictContains", ...col }));

/** Spread this into every <MaterialReactTable> that should use client-side filtering. */
export const defaultTableConfig = {
  /** Register the custom filter function so MRT resolves it by name. */
  filterFns: {
    strictContains,
  },
  /** Keep filter UI visible without enabling server-side filtering. */
  enableFilters: true,
  enableGlobalFilter: false,
  manualFiltering: false,
  initialState: {
    showColumnFilters: true,
    pagination: { pageSize: 100, pageIndex: 0 },
  },
};
